<template>
  <div>
    <Header />

    <div class="py-3">
      <div
        class="container mx-auto max-w-[1200px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-3 gap-5 mt-20 mb-10"
      >
        <!-- {{ totalPages }} -->

        <div
          @click="getInstructor(1)"
          class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
        >
          <div class="lg:px-8 h-full px-6 flex flex-col gap-4">
            <h1
              class="font-bold text-xl lg:text-xl prime text-center"
              v-if="this.userInfo"
            >
              Instructors
            </h1>

            <p
              v-if="this.staff_data"
              class="content max-w-sm text-center text-lg"
            >
              <span v-if="this.staff_data.instructors">{{
                this.staff_data.instructors.count
              }}</span>
            </p>

            <p
              class="bg-blues hover:bg-hover text-white px-3 py-1.5 rounded-full text-center"
            >
              See Details
            </p>
          </div>
        </div>

        <div
          @click="getCoordinator(1)"
          class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
        >
          <div class="lg:px-8 h-full px-6 flex flex-col gap-4">
            <h1
              class="font-bold text-xl lg:text-xl prime text-center"
              v-if="this.userInfo"
            >
              Coordinators
            </h1>

            <p
              v-if="this.staff_data"
              class="content max-w-sm text-center text-lg"
            >
              <span v-if="this.staff_data.coordinators">{{
                this.staff_data.coordinators.count
              }}</span>
            </p>

            <p
              class="bg-blues hover:bg-hover text-white px-3 py-1.5 rounded-full text-center"
            >
              See Details
            </p>
          </div>
        </div>

        <div
          @click="getStudent(1)"
          class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
        >
          <div class="lg:px-8 h-full px-6 flex flex-col gap-4">
            <h1
              class="font-bold text-xl lg:text-xl prime text-center"
              v-if="this.userInfo"
            >
              Students
            </h1>

            <p
              v-if="this.staff_data"
              class="content max-w-sm text-center text-lg"
            >
              <span v-if="this.staff_data.students">{{
                this.staff_data.students.count
              }}</span>
            </p>

            <p
              class="bg-blues hover:bg-hover text-white px-3 py-1.5 rounded-full text-center"
            >
              See Details
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-10 gap-5 mb-20">
        <div class="text-xl font-bold mb-10">
          {{ selectInfo }} ({{ totalCount }})
        </div>

        <div
          class="flex flex-col rounded-3xl shadow-xl h-full gap-5 overflow-x-auto"
        >
          <table class="table-auto w-full overflow-x-auto" :key="selectInfo">
            <thead>
              <tr>
                <th
                  class="p-4 border-b text-center border-r text-textblues whitespace-nowrap"
                >
                  S NO
                </th>
                <th class="p-4 border-b text-center border-r text-textblues">
                  Name
                </th>
                <th class="p-4 border-b border-r text-center text-textblues">
                  Email
                </th>

                <th
                  class="p-4 border-b text-center text-textblues"
                  v-if="this.selectInfo != 'Students'"
                >
                  Change Permission
                </th>
              </tr>
            </thead>

            <tbody v-if="instructors.length != 0">
              <tr v-for="(instructor, index) in instructors" :key="instructor">
                <td class="p-4 border-b text-center border-r">
                  <p class="text-primary">
                    {{ (currentPage - 1) * 10 + index + 1 }}
                  </p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p class="text-primary" v-if="instructor.user">
                    {{ instructor.user.display_name }}
                  </p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p class="text-primary" v-if="instructor.user">
                    {{ instructor.user.email }}
                  </p>
                </td>

                <!-- <td class="p-4 border-b text-center border-r">
                <p class="text-primary" v-if="instructor.user">
                    {{ instructor.user.email }}
                </p>
              </td> -->

                <td
                  class="p-4 border-b text-center flex items-center justify-center"
                  v-if="this.selectInfo != 'Students'"
                >
                  <p
                    class="bg-primary text-white px-5 py-1.5 rounded-full text-sm text-center cursor-pointer"
                    v-if="this.selectInfo == 'Coordinators'"
                    @click="
                      getChangePermisson(instructor.user.id, 'instructor')
                    "
                  >
                    Change Instructor
                  </p>
                  <p
                    class="bg-primary text-white px-5 py-1.5 rounded-full text-sm text-center cursor-pointer"
                    v-if="this.selectInfo == 'Instructors'"
                    @click="
                      getChangePermisson(instructor.user.id, 'co-ordinator')
                    "
                  >
                    Change Coordinator
                  </p>
                </td>
              </tr>
            </tbody>

            <tbody v-if="instructors.length == 0">
              <tr>
                <td colspan="4" class="text-center p-4">No Details</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="flex items-center justify-center w-full pb-8"
          :key="selectInfo"
          v-if="selectInfo == 'Instructors'"
        >
          <Pagination :totalPages="totalPages" @page-changed="getInstructor" />
        </div>

        <div
          class="flex items-center justify-center w-full pb-8"
          :key="selectInfo"
          v-if="selectInfo == 'Coordinators'"
        >
          <Pagination :totalPages="totalPages" @page-changed="getCoordinator" />
        </div>

        <div
          class="flex items-center justify-center w-full pb-8"
          :key="selectInfo"
          v-if="selectInfo == 'Students'"
        >
          <Pagination :totalPages="totalPages" @page-changed="getStudent" />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Hod/Header.vue";
import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";

import Pagination from "@/components/Pagination.vue";

import axios from "axios";

export default {
  components: {
    Header,
    Footer,
    Pagination,
  },
  computed: mapGetters(["userInfo"]),

  data() {
    return {
      staff_data: [],
      instructors: [],
      selectInfo: "Instructors",

      totalCount: null,
      totalPages: 0,
      currentPage: 1,
    };
  },

  created() {
    this.getStaffDataCounts();
    this.getInstructor(1);
  },

  methods: {
    getStaffDataCounts() {
      axios
        .get(
          `${process.env.VUE_APP_API}/hod-login/staff-data/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.staff_data = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getInstructor(number) {
      this.currentPage = number;
      this.selectInfo = "Instructors";
      await axios
        .get(
          `${process.env.VUE_APP_API}/hod_instructor/?Key=${this.userInfo.token_key}&page=${number}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            // this.instructors = response.data.data.data;
            this.totalCount = response.data.count;
            this.instructors = response.data.data.data.data;
            this.totalPages = response.data.data.total_page;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getCoordinator(number) {
      this.currentPage = number;
      this.selectInfo = "Coordinators";
      await axios
        .get(
          `${process.env.VUE_APP_API}/hod_coordinator/?Key=${this.userInfo.token_key}&page=${number}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            // this.instructors = response.data.data.data;
            this.totalCount = response.data.count;
            this.instructors = response.data.data.data.data;
            this.totalPages = response.data.data.total_page;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getStudent(number) {
      this.currentPage = number;
      this.selectInfo = "Students";
      await axios
        .get(
          `${process.env.VUE_APP_API}/hod_student/?Key=${this.userInfo.token_key}&page=${number}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            // this.instructors = response.data.data.data;
            this.totalCount = response.data.count;
            this.instructors = response.data.data.data.data;
            this.totalPages = response.data.data.total_page;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getChangePermisson(id, value) {
      // this.selectInfo = "Students";
      axios
        .put(
          `${process.env.VUE_APP_API}/user_permission_change/${id}/?Key=${this.userInfo.token_key}`,
          {
            permission: value,
          },
        )
        .then((response) => {
          if (response.data.status == 200) {
            // this.instructors = response.data.data.data;
            if (this.selectInfo == "Instructors") {
              this.getInstructor(1);
              this.getStaffDataCounts();
            }
            if (this.selectInfo == "Coordinators") {
              this.getCoordinator(1);
              this.getStaffDataCounts();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
